import { JwtToken } from '@src/shared/services/user-api'
import { getUserToken } from '@src/shared/providers/UserProvider'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const AuthPage = () => {
  const navigate = useNavigate()
  const token: JwtToken = { jwt: getUserToken() }
  useEffect(() => {
    navigate('/')
  }, [navigate, token.jwt])

  return <div />
}

export default AuthPage
